import { OrganizationFormSchemaType } from ".";

export const ORGANIZATION_FORM_DEFAULT_VALUES: Partial<OrganizationFormSchemaType> = {
    name: undefined,
    crm_connections: [],
    organization_type: undefined,
};
